<template>
  <div class="leader-box">
    <div class="user-img-box">
      <img :src="data.image" alt="" class="user-image">
    </div>
    <div class="flex">
      <div class="leader-name">
        <p>{{data.ceo_name}}</p>
        <div class="tag">
          <img src="https://files.wondercv.com/m/ai/master.png" alt="" width="12" height="12">
          <span>行业大佬</span>
        </div>
      </div>
      <div class="company">{{data.company_name}} · {{data.position}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Leader",
    props:{
      data:{
        type: Object,
        default:()=>({})
      }
    }
  }
</script>

<style scoped lang="scss">
.leader-box{
  position: relative;
  box-sizing: border-box;
  padding: 22px 20px 6px 20px;
  display: flex;
  .user-img-box{
    width: 67px;
    height: 67px;
    border: 2px solid #7E53E8;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-right: 14px;
    .user-image{
      width: 59px;
      height: 59px;
      border-radius: 50%;
    }
  }
  .flex{
    display: flex;
    flex-direction: column;
    justify-content: center;
    .leader-name{
      margin-bottom: 2px;
      display: flex;
      align-items: center;
      p{
        font-size: 20px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 28px;
        margin-right: 8px;
      }
      div{
        height: 18px;
        background: #401E94;
        border-radius: 0px 4px 4px 4px;
        display: flex;
        align-items: center;
        font-size: 11px;
        line-height: 16px;
        padding: 0 5px;
        box-sizing: border-box;
        color: #CBB5FF;
        img{
          margin-right: 2px;
        }
      }
    }
    .company{
      font-size: 14px;
      font-weight: 400;
      color: #CBB5FF;
      line-height: 20px;
    }
  }
}
</style>